/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1XIcon20Solid = forwardRef('People1XIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.168 6.168a4.167 4.167 0 1 1-8.335 0 4.167 4.167 0 0 1 8.335 0Z" }),
        React.createElement("path", { d: "M10.891 12.017c-.32-.013-.62-.017-.891-.017-2.362 0-6.887.29-7.827 4.369C1.97 17.252 2.735 18 3.641 18h6.9c.1-.594.38-1.163.838-1.621l.378-.379-.378-.379a3.001 3.001 0 0 1-.488-3.604Z" }),
        React.createElement("path", { d: "M14.207 12.793a1 1 0 0 0-1.414 1.414L14.586 16l-1.793 1.793a1 1 0 0 0 1.414 1.414L16 17.414l1.793 1.793a1 1 0 0 0 1.414-1.414L17.414 16l1.793-1.793a1 1 0 0 0-1.414-1.414L16 14.586l-1.793-1.793Z" })));
});
